import { Videocam, VideoSettings } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { hireflixCta, hireflixCtaHover } from '@styles/colors';
import { FC } from 'react';
import { Link } from 'react-router-dom';

// import { ErrorIcon } from '../../../../vectors/index';

type HireflixPositionNotFoundModalProps = {
  // position?: string;
  isOpen: boolean;
  handleClose: () => void;
};

const HireflixPositionNotFoundModal: FC<HireflixPositionNotFoundModalProps> = ({
  // position,
  isOpen,
  handleClose,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      disableEnforceFocus
      sx={{ '& .MuiPaper-root': { maxWidth: '450px !important' } }}
    >
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>

        <br />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '64px',
            height: '64px',
            margin: '0 auto',
            borderRadius: '100%',
            backgroundColor: 'rgb(243, 232, 255)',
            mb: 1,
          }}
        >
          <VideoSettings sx={{ fontSize: 40, color: hireflixCta }} />
        </Box>

        <Typography variant="h4" sx={{ p: 3 }}>
          Interview Setup Required
          {/* {position && (
            <Typography variant="subtitle1" color="text.secondary">
              &quot;{position}&quot;
            </Typography>
          )} */}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ mb: 8, textAlign: 'center' }}>
          This position doesn’t have a Hireflix interview set up yet. To send
          this invite, you’ll need to create the interview first.
          <br /> <br />
          It takes about a minute and saves hours - Let’s do it!
        </Typography>

        <Stack spacing={2} width="100%">
          <Button
            variant="contained"
            color="primary"
            startIcon={<Videocam />}
            fullWidth
            component={Link}
            to="/employer/hireflix-interviews"
            sx={{
              backgroundColor: hireflixCta,
              '&:hover': {
                backgroundColor: hireflixCtaHover,
              },
            }}
          >
            Create Interview
          </Button>
          <Button
            variant="outlined"
            color="info"
            fullWidth
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default HireflixPositionNotFoundModal;
